import alt from "@cirrus/legacy/app-author/alt/alt.es6"
import { notificationType } from "../constants/constants.es6"

let lastNotification = null

const NotificationActions = {
  show(type, text, timeout, showOnlyOneNotification, hideLastNotification, dataQa) {
    if (showOnlyOneNotification && lastNotification != null && lastNotification.isShown()) {
      lastNotification.prolongShow()
      return
    }

    if (hideLastNotification && lastNotification != null && lastNotification.isShown()) {
      lastNotification.hide()
    }

    lastNotification = this._getNotification(type).show(text, timeout, false, dataQa)

    return lastNotification
  },

  hide() {
    if (lastNotification != null && lastNotification.isShown()) {
      lastNotification.hide()
      lastNotification = null
    }
  },

  _getNotification(type) {
    switch (type) {
      case notificationType.success:
        return App.module("Notification.Success")
      case notificationType.error:
        return App.module("Notification.Error")
      case notificationType.warning:
        return App.module("Notification.Alert")
      case notificationType.info:
        return App.module("Notification.Info")
      default:
        throw Error(`Notification type "${type}" not supported`)
    }
  }
}

export default alt.createActions(NotificationActions)
